import {Component, inject} from '@angular/core';
import {FormBuilder, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {Router, RouterLink} from '@angular/router';
import {MtxButtonModule} from '@ng-matero/extensions/button';
import {TranslateModule} from '@ngx-translate/core';
import {SSOService} from "../../../services/sso/SSOService";
import {ToastrService} from "ngx-toastr";
import {SessionManager} from "../../../manager/SessionManager";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MtxButtonModule,
  ],
  providers: [SSOService, SessionManager]
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);

  constructor(private router: Router,
              private sessionManager: SessionManager,
              private toastrService: ToastrService,
              private ssoService: SSOService
  ) {
  }


  isSubmitting = false;

  loginForm = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.min(8)]]
  });


  login() {
    if (this.loginForm.valid) {
      this.isSubmitting = true
      this.ssoService.authEmail(
        this.loginForm.controls.email.value,
        this.loginForm.controls.password.value)
        .subscribe(response => {
          console.log(response)
          this.isSubmitting = false
          this.sessionManager.auth(response.data)
          this.router.navigateByUrl("/catalog")
        }, e => {
          this.isSubmitting = false
        })
    }
  }
}
